// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Traffic Config API
 * traffic-config-api manages traffic configuration for the Aura platform.
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface TrafficconfigGcpStatus
 */
export interface TrafficconfigGcpStatus {
  /**
   *
   * @type {string}
   * @memberof TrafficconfigGcpStatus
   */
  serviceAttachmentUrl?: string;
}

/**
 * Check if a given object implements the TrafficconfigGcpStatus interface.
 */
export function instanceOfTrafficconfigGcpStatus(
  value: object,
): value is TrafficconfigGcpStatus {
  return true;
}

export function TrafficconfigGcpStatusFromJSON(
  json: any,
): TrafficconfigGcpStatus {
  return TrafficconfigGcpStatusFromJSONTyped(json, false);
}

export function TrafficconfigGcpStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TrafficconfigGcpStatus {
  if (json == null) {
    return json;
  }
  return {
    serviceAttachmentUrl:
      json['service_attachment_url'] == null
        ? undefined
        : json['service_attachment_url'],
  };
}

export function TrafficconfigGcpStatusToJSON(
  json: any,
): TrafficconfigGcpStatus {
  return TrafficconfigGcpStatusToJSONTyped(json, false);
}

export function TrafficconfigGcpStatusToJSONTyped(
  value?: TrafficconfigGcpStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    service_attachment_url: value['serviceAttachmentUrl'],
  };
}
